// Mobile Accordion Toggle Function
function toggleMobAccordion(btn) {
  const item = btn ? btn.closest('.custom-mob-acc-item') : null;
  if (!item) return;
  const wasOpen = item.classList.contains('open');
  
  // Close all other brand accordions for clean accordion UX
  document.querySelectorAll('.custom-mob-acc-item').forEach(el => el.classList.remove('open'));
  
  if (!wasOpen) {
    item.classList.add('open');
  }
}
window.toggleMobAccordion = toggleMobAccordion;

/* Custom Biker Navigation & Smart Advisor Logic */
let advCurrentStep = 1;
let advSelectedBrands = ['all'];
let advSelectedTextiles = ['all'];
let advSelectedGenders = ['men'];
let advSelectedSizes = [];
const advAdultSizes = ['XS','S','M','L','XL','XXL','3XL','4XL','5XL','6XL','7XL','8XL'];
const advKidsSizes = ['104','110','116','122','128','134','140','146','152','158','164'];
let advReturnFocus = null;
let customNavTimer = null;

document.addEventListener('DOMContentLoaded', () => {
  // Mega-menu hover debounce bridge
  document.querySelectorAll('.custom-nav-item').forEach(item => {
    item.addEventListener('mouseenter', () => {
      clearTimeout(customNavTimer);
      document.querySelectorAll('.custom-nav-item').forEach(el => el.classList.remove('open'));
      item.classList.add('open');
    });
    item.addEventListener('mouseleave', () => {
      customNavTimer = setTimeout(() => {
        item.classList.remove('open');
      }, 280);
    });
  });
});

function openProductAdvisor() {
  const modal = document.getElementById('custom-advisor-modal');
  if (!modal) return;
  advReturnFocus = document.activeElement;
  syncAdvisorSelections();
  modal.style.display = 'flex';
  document.body.classList.add('advisor-open');
  requestAnimationFrame(() => {
    const closeButton = modal.querySelector('.custom-advisor-close');
    if (closeButton) closeButton.focus();
  });
}
function closeProductAdvisor() {
  const modal = document.getElementById('custom-advisor-modal');
  if (!modal) return;
  modal.style.display = 'none';
  document.body.classList.remove('advisor-open');
  if (advReturnFocus && typeof advReturnFocus.focus === 'function') advReturnFocus.focus();
}
function closeProductAdvisorOnBackdrop(e) {
  if (e.target.id === 'custom-advisor-modal') {
    closeProductAdvisor();
  }
}
function openProductAdvisorWithGender(g) {
  advSelectedGenders = [g];
  if (g === 'kids') advSelectedSizes = advKidsSizes.slice();
  else if (advSelectedSizes.some(size => advKidsSizes.includes(size))) advSelectedSizes = ['L','XL','XXL'];
  syncAdvisorSelections();
  updateGenderSummary();
  updateSizeSummary();
  openProductAdvisor();
  // Mark selected card in slide 3
  document.querySelectorAll('#adv-slide-3 .custom-opt-card').forEach(c => {
    if (c.getAttribute('data-slug') === g) {
      c.classList.add('selected');
    } else {
      c.classList.remove('selected');
    }
  });
  advGoToStep(3);
}

function openProductAdvisorWithSizes(sizes) {
  advSelectedSizes = Array.isArray(sizes) ? sizes.map(String).filter(size => advAdultSizes.includes(size) || advKidsSizes.includes(size)) : [];
  if (advSelectedSizes.some(size => advKidsSizes.includes(size))) {
    advSelectedGenders = ['kids'];
  } else {
    advSelectedGenders = ['men'];
  }
  updateGenderSummary();
  syncAdvisorSelections();
  updateSizeSummary();
  openProductAdvisor();
  advGoToStep(4);
}

function syncAdvisorSelections() {
  document.querySelectorAll('.custom-opt-card, .custom-chip, .custom-step-tab').forEach(el => {
    el.tabIndex = 0;
    if (el.matches('.custom-opt-card, .custom-chip')) {
      el.setAttribute('role', 'button');
      if (el.matches('.custom-opt-card')) {
        const slide = el.closest('.custom-adv-slide');
        const slug = el.dataset.slug;
        const selected = slide?.id === 'adv-slide-1' ? (slug === 'all' ? advSelectedBrands.includes('all') : advSelectedBrands.includes(slug)) :
          slide?.id === 'adv-slide-2' ? (slug === 'all' ? advSelectedTextiles.includes('all') : advSelectedTextiles.includes(slug)) :
          slide?.id === 'adv-slide-3' ? advSelectedGenders.includes(slug) : false;
        el.classList.toggle('selected', selected);
      } else if (el.matches('.custom-chip')) {
        el.classList.toggle('selected', advSelectedSizes.includes(el.textContent.trim()));
      }
      el.setAttribute('aria-pressed', el.classList.contains('selected') ? 'true' : 'false');
    }
    if (el.matches('.custom-step-tab')) {
      el.setAttribute('role', 'button');
      el.setAttribute('aria-current', el.classList.contains('active') ? 'step' : 'false');
    }
  });
  document.querySelectorAll('#adv-slide-4 .custom-chip').forEach(chip => {
    const size = chip.textContent.trim();
    const kidsOnly = advSelectedGenders.length === 1 && advSelectedGenders[0] === 'kids';
    const visible = kidsOnly ? advKidsSizes.includes(size) :
      advSelectedGenders.includes('kids') ? (advKidsSizes.includes(size) || advAdultSizes.includes(size)) : advAdultSizes.includes(size);
    chip.hidden = !visible;
  });
  document.querySelectorAll('.custom-size-presets button').forEach(button => {
    button.hidden = advSelectedGenders.length === 1 && advSelectedGenders[0] === 'kids' && button.dataset.preset !== 'all';
  });
  const allPreset = document.querySelector('.custom-size-presets [data-preset="all"]');
  if (allPreset) allPreset.textContent = advSelectedGenders.length === 1 && advSelectedGenders[0] === 'kids' ? 'Alle Kindergrößen' : 'Alle Größen';
}

document.addEventListener('keydown', event => {
  const modal = document.getElementById('custom-advisor-modal');
  if (!modal || modal.style.display === 'none') return;
  if (event.key === 'Escape') {
    event.preventDefault();
    closeProductAdvisor();
    return;
  }
  if (event.key !== 'Tab') return;
  const focusable = Array.from(modal.querySelectorAll('button:not([disabled]), [tabindex="0"]')).filter(el => !el.hidden && el.getClientRects().length);
  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  if (event.shiftKey && (document.activeElement === first || !modal.contains(document.activeElement))) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && (document.activeElement === last || !modal.contains(document.activeElement))) {
    event.preventDefault();
    first.focus();
  }
});

document.addEventListener('keydown', event => {
  if (!['Enter',' '].includes(event.key) || !event.target.matches('.custom-opt-card, .custom-chip, .custom-step-tab')) return;
  event.preventDefault();
  event.target.click();
});

function advGoToStep(step) {
  if (step < 1 || step > 4) return;
  advCurrentStep = step;
  document.querySelectorAll('.custom-adv-slide').forEach((s, idx) => {
    s.classList.toggle('active', idx + 1 === step);
  });
  document.querySelectorAll('.custom-step-tab').forEach((t, idx) => {
    t.classList.toggle('active', idx + 1 === step);
    t.setAttribute('aria-current', idx + 1 === step ? 'step' : 'false');
  });

  const btnPrev = document.getElementById('adv-btn-prev');
  const btnNext = document.getElementById('adv-btn-next');

  if (btnPrev) btnPrev.style.visibility = step === 1 ? 'hidden' : 'visible';
  if (btnNext) {
    if (step === 4) {
      btnNext.innerHTML = 'Ergebnisse anzeigen ➔';
    } else {
      btnNext.innerHTML = 'Weiter zu Schritt ' + (step + 1) + ' ➔';
    }
  }
  syncAdvisorSelections();
}

function advNextStep() {
  if (advCurrentStep < 4) {
    advGoToStep(advCurrentStep + 1);
  } else {
    // Use product search for every combination so unavailable collection handles cannot cause a 404.
    closeProductAdvisor();

    const brands = advSelectedBrands.filter(b => b !== 'all');
    const textiles = advSelectedTextiles.filter(t => t !== 'all');

    const brandSearchMap = {
      'gorilla-biker': 'Gorilla Biker',
      'gorilla-blood': 'Gorilla Blood',
      'silberruecken': 'Silberrücken',
      'steadfast': 'Steadfast',
      'steadfast-darkside': 'Darkside',
      'roughneck': 'Roughneck'
    };

    const textileSearchMap = {
      't-shirts': 'T-Shirt',
      'hoodies': 'Hoodie',
      'jacken': 'Jacke',
      'westen': 'Weste',
      'longsleeves': 'Longsleeve',
      'tank-tops': 'Muskelshirt',
      'hemden': 'Hemd',
      'hosen': 'Hose'
    };

    const genderSearchMap = {
      'men': ['Herren'],
      'women': ['Damen'],
      // The public Kids collection currently includes adult-titled Damen products; this is best-effort until catalog data is corrected.
      'kids': ['Kids', 'Kinder']
    };

    let queryParts = [];
    if (brands.length > 0) {
      const brandTerms = brands.map(b => 'title:"' + (brandSearchMap[b] || b) + '"');
      queryParts.push(brandTerms.length === 1 ? brandTerms[0] : '(' + brandTerms.join(' OR ') + ')');
    }
    if (textiles.length > 0) {
      const textileTerms = textiles.map(t => 'title:' + (textileSearchMap[t] || t));
      queryParts.push(textileTerms.length === 1 ? textileTerms[0] : '(' + textileTerms.join(' OR ') + ')');
    }
    if (advSelectedGenders.length > 0 && advSelectedGenders.length < 3) {
      const genderTerms = advSelectedGenders.flatMap(g => genderSearchMap[g] || [g]);
      queryParts.push('(' + genderTerms.map(term => 'title:' + term).join(' OR ') + ')');
    }

    let finalQuery = queryParts.join(' ').trim();
    if (!finalQuery) {
      finalQuery = 'Biker';
    }

    const allSizes = advSelectedGenders.length === 1 && advSelectedGenders[0] === 'kids' ? advKidsSizes : advAdultSizes;
    const kidsOnly = advSelectedGenders.length === 1 && advSelectedGenders[0] === 'kids';
    const selectedSizes = kidsOnly && advSelectedSizes.length === 0 ? advKidsSizes : advSelectedSizes;
    if (selectedSizes.length > 0 && (kidsOnly || selectedSizes.length < allSizes.length)) {
      queryParts.push(selectedSizes.length === 1
        ? selectedSizes[0]
        : '(' + selectedSizes.join(' OR ') + ')');
      finalQuery = queryParts.join(' ').trim();
    }
    const targetUrl = '/search?type=product&q=' + encodeURIComponent(finalQuery);
    window.location.href = targetUrl;
  }
}

function advPrevStep() {
  if (advCurrentStep > 1) {
    advGoToStep(advCurrentStep - 1);
  }
}

/* ==========================================================================
   MULTI-SELECT HANDLERS
   ========================================================================== */

// 1. BRAND TOGGLE
function advToggleBrand(slug, name, el) {
  if (slug === 'all') {
    advSelectedBrands = ['all'];
    document.querySelectorAll('#adv-slide-1 .custom-opt-card').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');
  } else {
    advSelectedBrands = advSelectedBrands.filter(b => b !== 'all');
    const allCard = document.querySelector('#adv-slide-1 .custom-opt-card[data-slug="all"]');
    if (allCard) allCard.classList.remove('selected');

    if (advSelectedBrands.includes(slug)) {
      advSelectedBrands = advSelectedBrands.filter(b => b !== slug);
      el.classList.remove('selected');
    } else {
      advSelectedBrands.push(slug);
      el.classList.add('selected');
    }

    if (advSelectedBrands.length === 0) {
      advSelectedBrands = ['all'];
      if (allCard) allCard.classList.add('selected');
    }
  }
  syncAdvisorSelections();
  updateBrandSummary();
}

function updateBrandSummary() {
  const sum = document.getElementById('adv-sum-1');
  if (!sum) return;
  if (advSelectedBrands.includes('all') || advSelectedBrands.length >= 6) {
    sum.innerText = 'Alle 6 Marken';
  } else {
    const brandMap = {
      'gorilla-biker': 'Gorilla Biker',
      'gorilla-blood': 'Gorilla Blood',
      'silberruecken': 'Silberrücken',
      'steadfast': 'Steadfast',
      'steadfast-darkside': 'Darkside',
      'roughneck': 'Roughneck'
    };
    const names = advSelectedBrands.map(s => brandMap[s] || s);
    if (names.length <= 2) {
      sum.innerText = names.join(', ');
    } else {
      sum.innerText = names.length + ' Marken gewählt';
    }
  }
}

// 2. TEXTILE TOGGLE
function advToggleTextile(slug, name, el) {
  if (slug === 'all') {
    advSelectedTextiles = ['all'];
    document.querySelectorAll('#adv-slide-2 .custom-opt-card').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');
  } else {
    advSelectedTextiles = advSelectedTextiles.filter(t => t !== 'all');
    const allCard = document.querySelector('#adv-slide-2 .custom-opt-card[data-slug="all"]');
    if (allCard) allCard.classList.remove('selected');

    if (advSelectedTextiles.includes(slug)) {
      advSelectedTextiles = advSelectedTextiles.filter(t => t !== slug);
      el.classList.remove('selected');
    } else {
      advSelectedTextiles.push(slug);
      el.classList.add('selected');
    }

    if (advSelectedTextiles.length === 0) {
      advSelectedTextiles = ['all'];
      if (allCard) allCard.classList.add('selected');
    }
  }
  syncAdvisorSelections();
  updateTextileSummary();
}

function updateTextileSummary() {
  const sum = document.getElementById('adv-sum-2');
  if (!sum) return;
  if (advSelectedTextiles.includes('all')) {
    sum.innerText = 'Alle Textilien';
  } else {
    const map = {
      't-shirts': 'T-Shirts',
      'hoodies': 'Hoodies',
      'jacken': 'Jacken',
      'westen': 'Westen',
      'longsleeves': 'Longsleeves',
      'tank-tops': 'Muskelshirts',
      'hemden': 'Hemden',
      'hosen': 'Hose'
    };
    const names = advSelectedTextiles.map(s => map[s] || s);
    if (names.length <= 2) {
      sum.innerText = names.join(', ');
    } else {
      sum.innerText = names.length + ' Kategorien';
    }
  }
}

// 3. GENDER TOGGLE
function advToggleGender(slug, name, el) {
  if (advSelectedGenders.includes(slug)) {
    if (advSelectedGenders.length > 1) {
      advSelectedGenders = advSelectedGenders.filter(g => g !== slug);
      el.classList.remove('selected');
    }
  } else {
    advSelectedGenders.push(slug);
    el.classList.add('selected');
  }
  if (advSelectedGenders.includes('kids') && !advSelectedGenders.some(gender => gender !== 'kids')) {
    if (!advSelectedSizes.some(size => advKidsSizes.includes(size))) advSelectedSizes = advKidsSizes.slice();
  } else if (advSelectedSizes.some(size => advKidsSizes.includes(size))) {
    advSelectedSizes = ['L','XL','XXL'];
  }
  syncAdvisorSelections();
  updateSizeSummary();
  updateGenderSummary();
}

function updateGenderSummary() {
  const sum = document.getElementById('adv-sum-3');
  if (!sum) return;
  const map = { 'men': 'Herren', 'women': 'Damen', 'kids': 'Kids' };
  const names = advSelectedGenders.map(g => map[g] || g);
  if (names.length === 3) {
    sum.innerText = 'Alle (Familie)';
  } else {
    sum.innerText = names.join(' & ');
  }
}

// 4. SIZE TOGGLE & PRESETS
function advToggleSize(sz, el) {
  if (advSelectedSizes.includes(sz)) {
    advSelectedSizes = advSelectedSizes.filter(s => s !== sz);
    el.classList.remove('selected');
  } else {
    advSelectedSizes.push(sz);
    el.classList.add('selected');
  }
  syncAdvisorSelections();
  updateSizeSummary();
}

function advSelectSizePreset(preset) {
  document.querySelectorAll('#adv-slide-4 .custom-chip').forEach(c => c.classList.remove('selected'));
  if (preset === 'all') {
    advSelectedSizes = advSelectedGenders.includes('kids') ? advKidsSizes.slice() : advAdultSizes.slice();
  } else if (preset === 'standard') {
    advSelectedSizes = advSelectedGenders.includes('kids') ? advKidsSizes.slice() : ['M','L','XL','XXL'];
  } else if (preset === 'kingsize') {
    advSelectedSizes = advSelectedGenders.includes('kids') ? advKidsSizes.slice() : ['3XL','4XL','5XL','6XL','7XL','8XL'];
  }
  syncAdvisorSelections();
  document.querySelectorAll('#adv-slide-4 .custom-chip').forEach(c => {
    const sz = c.innerText.trim();
    if (advSelectedSizes.includes(sz)) c.classList.add('selected');
  });
  updateSizeSummary();
}

function updateSizeSummary() {
  const sum = document.getElementById('adv-sum-4');
  if (!sum) return;
  if (advSelectedSizes.length === 0 || advSelectedSizes.length >= 12) {
    sum.innerText = 'Alle Größen';
  } else if (advSelectedSizes.length <= 3) {
    sum.innerText = advSelectedSizes.join(', ');
  } else {
    sum.innerText = advSelectedSizes.length + ' Größen gewählt';
  }
}

// Backward compatibility aliases
function advSelectBrand(slug, name, el) { advToggleBrand(slug, name, el); }
function advSelectTextile(slug, name, el) { advToggleTextile(slug, name, el); }
function advSelectGender(g, name, el) { advToggleGender(g, name, el); }

/* ============================================================ */
/* BIKER EASTER EGG (PULL-TO-REVEAL BEHIND FOOTER)             */
/* ============================================================ */
function initBikerEasterEgg() {
  const viewport = document.querySelector('.layout--viewport');
  const easterEgg = document.getElementById('biker-easter-egg');
  if (!viewport || !easterEgg) return;

  const getFooter = () => document.querySelector('.layout--footer-group') || document.querySelector('.footer--root');

  const getDocHeight = () => Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight
  );

  const isAtPageBottom = () => {
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const windowH = window.innerHeight;
    return (scrollY + windowH >= getDocHeight() - 14);
  };

  let isDragging = false;
  let startY = 0;
  let currentPull = 0;
  let snapTimeout = null;
  let isSnapping = false;

  const getMaxPull = () => (window.innerWidth <= 768 ? 380 : 460);

  function updateEasterEggBasePosition() {
    const footer = getFooter();
    if (footer) {
      const rect = footer.getBoundingClientRect();
      easterEgg.style.top = rect.bottom + 'px';
    } else {
      easterEgg.style.top = window.innerHeight + 'px';
    }
  }

  function checkBottomState() {
    if (isAtPageBottom()) {
      updateEasterEggBasePosition();
      easterEgg.classList.add('active');
    } else if (!isDragging && currentPull === 0 && !snapTimeout) {
      easterEgg.classList.remove('active');
    }
  }

  window.addEventListener('scroll', checkBottomState, { passive: true });
  window.addEventListener('resize', checkBottomState, { passive: true });

  function setPull(distance) {
    clearTimeout(snapTimeout);
    currentPull = Math.max(0, Math.min(getMaxPull(), distance));
    if (currentPull > 0) {
      updateEasterEggBasePosition();
      easterEgg.classList.add('active');
      const transformValue = `translateY(-${currentPull}px)`;
      viewport.style.transform = transformValue;
      easterEgg.style.transform = transformValue;
    } else {
      viewport.style.transform = '';
      easterEgg.style.transform = '';
    }
  }

  function snapBack() {
    if (currentPull === 0) return;
    isSnapping = true;
    // Smoother and slightly longer return glide (0.65s)
    const springTransition = 'transform 0.65s cubic-bezier(0.22, 1, 0.36, 1)';
    viewport.style.transition = springTransition;
    easterEgg.style.transition = springTransition;
    viewport.style.transform = 'translateY(0px)';
    easterEgg.style.transform = 'translateY(0px)';

    setTimeout(() => {
      viewport.style.transition = '';
      easterEgg.style.transition = '';
      viewport.style.transform = '';
      easterEgg.style.transform = '';
      currentPull = 0;
      isSnapping = false;
      snapTimeout = null;
      checkBottomState();
    }, 660);
  }

  // 500ms DELAY before snap-back so user can clearly view image & text
  function triggerSnapBackWithDelay(delay = 500) {
    clearTimeout(snapTimeout);
    snapTimeout = setTimeout(() => {
      snapBack();
    }, delay);
  }

  // --- TOUCH SUPPORT (Mobile & Tablet) ---
  let touchActive = false;
  window.addEventListener('touchstart', (e) => {
    if (isSnapping) return;
    clearTimeout(snapTimeout);
    if (isAtPageBottom()) {
      touchActive = true;
      startY = e.touches[0].clientY;
      checkBottomState();
    }
  }, { passive: true });

  window.addEventListener('touchmove', (e) => {
    if (!touchActive) {
      if (isAtPageBottom()) {
        touchActive = true;
        startY = e.touches[0].clientY;
      }
      return;
    }
    const currentY = e.touches[0].clientY;
    const deltaY = startY - currentY; // positive when pulling UP

    if (deltaY > 4) {
      const damped = Math.min(getMaxPull(), Math.pow(deltaY, 0.84) * 1.5);
      viewport.style.transition = '';
      easterEgg.style.transition = '';
      setPull(damped);
      if (e.cancelable) {
        e.preventDefault();
      }
    } else if (deltaY < -10) {
      setPull(0);
      touchActive = false;
    }
  }, { passive: false });

  window.addEventListener('touchend', () => {
    if (touchActive || currentPull > 0) {
      touchActive = false;
      // Pause 500ms before snapping back
      triggerSnapBackWithDelay(500);
    }
  }, { passive: true });

  window.addEventListener('touchcancel', () => {
    touchActive = false;
    triggerSnapBackWithDelay(500);
  }, { passive: true });

  // --- MOUSE DRAG SUPPORT (Desktop) ---
  window.addEventListener('mousedown', (e) => {
    if (isSnapping) return;
    if (e.button !== 0) return;
    clearTimeout(snapTimeout);
    if (e.target.closest('a, button, input, select, textarea, [data-drawer-open], .custom-nav-item')) return;

    if (isAtPageBottom()) {
      isDragging = true;
      startY = e.clientY;
      checkBottomState();
    }
  });

  window.addEventListener('mousemove', (e) => {
    if (!isDragging) return;
    const deltaY = startY - e.clientY;
    if (deltaY > 4) {
      const damped = Math.min(getMaxPull(), Math.pow(deltaY, 0.84) * 1.5);
      viewport.style.transition = '';
      easterEgg.style.transition = '';
      setPull(damped);
      document.body.style.cursor = 'grabbing';
      e.preventDefault();
    } else if (deltaY < -10) {
      setPull(0);
    }
  });

  window.addEventListener('mouseup', () => {
    if (isDragging || currentPull > 0) {
      isDragging = false;
      document.body.style.cursor = '';
      // Pause 500ms before snapping back
      triggerSnapBackWithDelay(500);
    }
  });

  // --- MOUSE WHEEL AT BOTTOM (Desktop Wheel Tug) ---
  window.addEventListener('wheel', (e) => {
    if (isSnapping) return;
    if (isAtPageBottom() && e.deltaY > 0) {
      clearTimeout(snapTimeout);
      viewport.style.transition = '';
      easterEgg.style.transition = '';
      const added = e.deltaY * 0.4;
      setPull(currentPull + added);

      // Pause 600ms after last wheel stroke before returning
      triggerSnapBackWithDelay(600);
    }
  }, { passive: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBikerEasterEgg);
} else {
  initBikerEasterEgg();
}

/* ============================================================ */
/* UNIVERSAL HIGH-CONVERTING STICKY ADD-TO-CART (DESKTOP & MOB) */
/* ============================================================ */
function initUniversalStickyATC() {
  const drawer = document.querySelector('.product-buy-buttons--drawer');
  const mainBtn = document.querySelector('.product-buy-buttons--root > button.product-buy-buttons--primary');
  const pbb = document.querySelector('product-buy-buttons-element');
  if (!drawer || !mainBtn) return;

  // 1. Teleport drawer directly to document.body so no ancestor (e.g. .product-form sticky on desktop or .layout--footer-group) can trap its stacking context
  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  // 2. Disconnect Beyond Theme's bottom observer so it does not hide the bar when scrolling near footer / related products
  if (pbb && pbb.bottom_intersection_observer) {
    try {
      pbb.bottom_intersection_observer.disconnect();
    } catch(e) {}
  }

  // 3. Forward click from sticky button to the primary theme button (handles AJAX add-to-cart, cart-drawer opening, and stock validation)
  const stickyBtn = drawer.querySelector('.custom-sticky-btn, button.product-buy-buttons--primary');
  if (stickyBtn && !stickyBtn._hasHookedClick) {
    stickyBtn._hasHookedClick = true;
    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const currentMainBtn = document.querySelector('.product-buy-buttons--root > button.product-buy-buttons--primary');
      if (currentMainBtn && !currentMainBtn.disabled) {
        currentMainBtn.click();
      }
    });
  }

  // 4. Synchronize disabled state and button text with main button
  const syncBtnState = () => {
    const currentMainBtn = document.querySelector('.product-buy-buttons--root > button.product-buy-buttons--primary');
    if (stickyBtn && currentMainBtn) {
      stickyBtn.disabled = currentMainBtn.disabled;
      const ctaText = stickyBtn.querySelector('.product-buy-buttons--cta-text');
      const mainText = currentMainBtn.querySelector('.product-buy-buttons--cta-text') || currentMainBtn;
      if (ctaText && mainText) {
        ctaText.textContent = (mainText.textContent || '').trim();
      }
    }
  };
  syncBtnState();

  // 5. Observe mainBtn: show sticky bar only when user has scrolled past main buy button
  if (window._stickyAtcObserver) {
    window._stickyAtcObserver.disconnect();
  }

  window._stickyAtcObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        drawer.setAttribute('aria-hidden', 'false');
      } else {
        drawer.setAttribute('aria-hidden', 'true');
      }
    });
  }, {
    threshold: 0,
    rootMargin: '-10px 0px 0px 0px'
  });

  window._stickyAtcObserver.observe(mainBtn);

  // 6. Fast scroll synchronization via requestAnimationFrame
  if (!window._stickyScrollHandlerAttached) {
    window._stickyScrollHandlerAttached = true;
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentMainBtn = document.querySelector('.product-buy-buttons--root > button.product-buy-buttons--primary');
          const currentDrawer = document.querySelector('.product-buy-buttons--drawer');
          if (currentMainBtn && currentDrawer) {
            const rect = currentMainBtn.getBoundingClientRect();
            if (rect.bottom < 0) {
              currentDrawer.setAttribute('aria-hidden', 'false');
            } else if (rect.top > 0) {
              currentDrawer.setAttribute('aria-hidden', 'true');
            }
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initUniversalStickyATC);
} else {
  initUniversalStickyATC();
}
window.addEventListener('shopify:section:load', initUniversalStickyATC);
window.addEventListener('theme:product:variantChange', initUniversalStickyATC);
